import c0 from './configurations/show_controller';
import c1 from './feed_items/show_controller';
import c2 from './premiere_pages/show_controller';
import c3 from './threads/index_controller';
import c4 from './threads/origin_controller';
import c5 from './threads/title_controller';
export const definitions = [
	{identifier: 'configurations--show', controllerConstructor: c0},
	{identifier: 'feed-items--show', controllerConstructor: c1},
	{identifier: 'premiere-pages--show', controllerConstructor: c2},
	{identifier: 'threads--index', controllerConstructor: c3},
	{identifier: 'threads--origin', controllerConstructor: c4},
	{identifier: 'threads--title', controllerConstructor: c5},
];
